// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/G42-Sans/woff2/G42Sans-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/G42-Sans/woff/G42Sans-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* G42 Sans web font from client/src/assets/fonts/G42-Sans */
@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: 400 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
  font-weight: 400 500;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
  font-weight: 700 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'G42 Sans';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
  font-weight: 700 900;
  font-style: italic;
  font-display: swap;
}

/* Override any theme (e.g. Fluent UI Segoe UI) and set G42 Sans globally */
body,
html,
.Root,
#root,
body *,
.Root *,
#root * {
  font-family: 'G42 Sans' !important;
}

body,
html,
.Root {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

html,
body {
  /* Prevent pull down to refresh behavior on mobile */
  overscroll-behavior-y: contain;
}

.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,uBAAuB;EACvB;;0DAEuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAE6E;EAC7E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAEwE;EACxE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAE8E;EAC9E,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;0DAEuE;EACvE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;;2DAE6E;EAC7E,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;;;;;;;EAOE,kCAAkC;AACpC;;AAEA;;;EAGE,mCAAmC;EACnC,kCAAkC;EAClC,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["/* G42 Sans web font from client/src/assets/fonts/G42-Sans */\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-Light.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-Light.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-LightItalic.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-LightItalic.woff') format('woff');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-Medium.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-Medium.woff') format('woff');\n  font-weight: 400 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-MediumItalic.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-MediumItalic.woff') format('woff');\n  font-weight: 400 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-Black.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-Black.woff') format('woff');\n  font-weight: 700 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'G42 Sans';\n  src:\n    url('./assets/fonts/G42-Sans/woff2/G42Sans-BlackItalic.woff2') format('woff2'),\n    url('./assets/fonts/G42-Sans/woff/G42Sans-BlackItalic.woff') format('woff');\n  font-weight: 700 900;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* Override any theme (e.g. Fluent UI Segoe UI) and set G42 Sans globally */\nbody,\nhtml,\n.Root,\n#root,\nbody *,\n.Root *,\n#root * {\n  font-family: 'G42 Sans' !important;\n}\n\nbody,\nhtml,\n.Root {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nhtml,\nbody {\n  /* Prevent pull down to refresh behavior on mobile */\n  overscroll-behavior-y: contain;\n}\n\n.wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
